import React, { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import axios from "../Config/axios";

function Swiper() {
    const [index, setIndex] = useState(0);
    const [banners, setBanners] = useState([]);

    useEffect(() => {
        axios
            .get("banners/get")
            .then((res) => {
                let { code } = res.data;

                if (code === 200) {
                    setBanners(res?.data?.data?.banners);
                } else if (code === 400) {
                    setBanners(res?.data?.data?.banners);
                }
            })
            .catch(() => {
            });
    }, []);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <Carousel activeIndex={index} onSelect={handleSelect} interval={4000}>
            {banners.map((el, index) => (
                <Carousel.Item key={index}>
                    <img
                        className="d-block carousel-image"
                        src={el.url}
                        alt={el.name}
                    />
                </Carousel.Item>
            ))}
        </Carousel>
    );
}

export default Swiper;
